if (!customElements.get('featured-collections-tabs')) {
  class FeaturedCollectionsTabs extends HTMLElement {
    connectedCallback() {
      this.tabBtns = [...this.querySelectorAll('.featured-collections-tabs__tab')];
      this.panels = [...this.querySelectorAll('.featured-collections-tabs__panel')];

      this.tabBtns.forEach((btn, i) => {
        btn.addEventListener('click', () => this._switchTab(i));
      });
    }

    _switchTab(index) {
      this.tabBtns.forEach((btn, i) => {
        btn.classList.toggle('featured-collections-tabs__tab--active', i === index);
        btn.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });

      this.panels.forEach((panel, i) => {
        panel.classList.toggle('featured-collections-tabs__panel--active', i === index);
      });

      const slider = this.panels[index]?.querySelector('featured-collections-slider');
      if (slider) {
        requestAnimationFrame(() => {
          slider._applyLayout();
          slider.setPosition(false);
          slider.updateButtons();
        });
      }
    }
  }

  customElements.define('featured-collections-tabs', FeaturedCollectionsTabs);
}

if (!customElements.get('featured-collections-slider')) {
  class FeaturedCollectionsSlider extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.featured-collections-tabs__slider-viewport');
      this.track = this.querySelector('.featured-collections-tabs__slider-track');
      this.prevBtn = this.querySelector('.featured-collections-tabs__slider-btn--prev');
      this.nextBtn = this.querySelector('.featured-collections-tabs__slider-btn--next');

      this.currentIndex = 0;
      this._slideWidth = 0;
      this._gap = 0;
      this._totalSlides = this.track.children.length;

      this.prevBtn.addEventListener('click', () => this.prev());
      this.nextBtn.addEventListener('click', () => this.next());

      requestAnimationFrame(() => {
        if (window.innerWidth < 750) this._applyLayout();
      });

      this.resizeObserver = new ResizeObserver(() => {
        if (window.innerWidth < 750) return;
        this._applyLayout();
        this.setPosition(false);
        this.updateButtons();
      });

      this.resizeObserver.observe(this.viewport);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    get slidesPerView() {
      const desktop = parseInt(this.dataset.slidesPerView) || 4;
      return window.innerWidth < 990 ? Math.min(desktop, 4) : desktop;
    }

    get _isFit() {
      return this._totalSlides <= this.slidesPerView;
    }

    _applyLayout() {
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this._gap = gap;

      const vw = this.viewport.offsetWidth;
      if (!vw) return;

      if (window.innerWidth < 750) {
        const mobileWidth = (vw - gap) / 1.5;
        [...this.track.children].forEach(item => {
          item.style.width = `${Math.floor(mobileWidth)}px`;
        });
        return;
      }

      this._slideWidth = (vw - (this.slidesPerView - 1) * gap) / this.slidesPerView;

      [...this.track.children].forEach(item => {
        item.style.width = `${this._slideWidth}px`;
      });

      this.prevBtn.style.display = this._isFit ? 'none' : '';
      this.nextBtn.style.display = this._isFit ? 'none' : '';
    }

    getTranslateX(index) {
      return -(index * (this._slideWidth + this._gap));
    }

    setPosition(animate) {
      if (window.innerWidth < 750) return;
      if (this._isFit) {
        this.track.style.transition = 'none';
        this.track.style.transform = 'translateX(0)';
        return;
      }
      const x = this.getTranslateX(this.currentIndex);
      this.track.style.transition = animate ? 'transform 0.4s ease' : 'none';
      this.track.style.transform = `translateX(${x}px)`;
    }

    updateButtons() {
      if (window.innerWidth < 750 || this._isFit) return;
      const maxIndex = Math.max(0, this._totalSlides - this.slidesPerView);
      this.prevBtn.disabled = this.currentIndex <= 0;
      this.nextBtn.disabled = this.currentIndex >= maxIndex;
    }

    next() {
      const maxIndex = Math.max(0, this._totalSlides - this.slidesPerView);
      if (this.currentIndex >= maxIndex) return;
      this.currentIndex++;
      this.setPosition(true);
      this.updateButtons();
    }

    prev() {
      if (this.currentIndex <= 0) return;
      this.currentIndex--;
      this.setPosition(true);
      this.updateButtons();
    }
  }

  customElements.define('featured-collections-slider', FeaturedCollectionsSlider);
}
